export default __webpack_public_path__ + "static/media/key.c0ba3344.svg";